import { render } from "./PriceSlider.vue?vue&type=template&id=0f3717c8&scoped=true"
import script from "./PriceSlider.vue?vue&type=script&lang=js"
export * from "./PriceSlider.vue?vue&type=script&lang=js"

import "./PriceSlider.vue?vue&type=style&index=0&id=0f3717c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3717c8"]])

export default __exports__